/**
 * Собирает href раздела аккаунта из базы хоста и относительного пути.
 * Порт легаси `accountDomain + '#/...'`. Пустой `accountUrl` → относительный href.
 * Чистая функция, вход не мутирует.
 */
export function buildAccountHref(accountUrl: string, path: string): string {
  return (accountUrl ?? '') + path;
}
